import React, { useState } from 'react'
import { Form, Input, message, Modal } from 'antd'
import { useShangpinAddMutation } from '../../store/dianshangtaizhangApi';
import { PlusOutlined } from '@ant-design/icons';
function GoodsAdd() {
    const [form] = Form.useForm(); 
    const [submit] = useShangpinAddMutation();
    const [info,setInfo] = useState({
        sp_content:''
    })
    const [open, setOpen] = useState(false);
    return (
        <>
          <a onClick={() => {setOpen(true)}}><PlusOutlined /> 新增商品</a>
            <Modal
                open={open}
                title='新增商品'
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                width={1000}
                onOk={() => {
                    submit({
                        'sp_name': info.sp_name,
                        'sp_content': info.sp_content,
                        'sp_uid': localStorage.getItem('eu_id'),
                        'sp_uname': localStorage.getItem('eu_name')
                    }).then((res) => {
                        // console.log(res);
                        if (res.data.Status === 'success') {                            
                            message.success('新增成功！')   
                            setOpen(false)
                            form.resetFields();                          
                        }
                        if (res.data.Status === 'fail') {
                            message.error('新增失败！'+res.data.Message)
                        }
                    }) 
                }}
            >
                  <Form
                        form={form}
                        layout="horizonal"
                        name="form_client"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}   
                                    
                    >                                                       
                        <Form.Item name="sp_name" wrapperCol={{span:10}} required label='商品名称'>                        
                            <Input onChange={(e) => {
                                setInfo(prevState=>({...prevState,sp_name:e.target.value}))
                            }}/>
                        </Form.Item>                       
                                        
                        <Form.Item name="sp_content" wrapperCol={{span:10}} label='备注'>                        
                            <Input onChange={(e) => {
                                setInfo(prevState=>({...prevState,sp_content:e.target.value}))
                            }}/>
                        </Form.Item>                                                                                     
                    </Form>
            </Modal>
        </>
    )
}

export default GoodsAdd